<template>
  <div class="wordbook-wrap">
    <!-- 全屏页面自定义左上角返回按钮 -->
    <div class="page-back-btn" @click="$router.go(-1)">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2">
        <path d="M19 12H5M12 19l-7-7 7-7"></path>
      </svg>
    </div>
    <div v-if="wordList.length === 0" class="empty-tip">暂无收藏单词，阅读短文点击带下划线生词即可收藏</div>
    <div class="word-list" v-else>
      <div class="word-card" v-for="item in wordList" :key="item.word">
        <div class="w-name">{{ item.word }}</div>
        <div class="w-pho">音标：{{ item.phonetic }}</div>
        <div class="w-exp">释义：{{ item.desc }}</div>
        <!-- <button class="del-btn" @click="deleteWord(item.word)">移除</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { readerFetch } from "@/utils/request";
export default {
  name: 'WordBook',
  data() {
    return {
      wordList: []
    }
  },
  mounted() {
    this.loadWordList()
  },
  methods: {
    async loadWordList() {
      try {
        const res = await readerFetch("/word/list");
        if(res.code === 200 && res.data != null) {
          this.wordList = res.data;
        }
      }catch(err){
        console.error("加载生词失败", err)
      }
    },
    async deleteWord(word) {
      if(!confirm("确定移除此单词？")) return;
      try {
        await readerFetch(`/word/del/${word}`, { method: "DELETE" });
        this.loadWordList();
      }catch(err){
        alert("删除失败");
      }
    }
  }
}
</script>

<style scoped>
.wordbook-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #ffffffe5;
  z-index: 999;
  overflow-y: auto;
}
.empty-tip {
  font-size: 18px;
  color: #999;
  text-align: center;
  margin-top: 100px;
}
.word-list {
  margin: 75px 25px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}
.word-card {
  background: #ffd;
  padding: 18px;
  border-radius: 20px;
}
.w-name {
  font-size: 20px;
  font-weight: bold;
  color: #2d3748;
  margin-bottom: 6px;
}
.w-pho {
  color: #409eff;
  font-size: 14px;
  margin-bottom: 8px;
}
.w-exp {
  color: #555;
  margin-bottom: 12px;
  line-height: 1.6;
}
.del-btn {
  padding: 6px 12px;
  border: none;
  background: #f56c6c;
  color: white;
  border-radius: 4px;
  cursor: pointer;
}
</style>